import React, { useState, useEffect, useMemo } from 'react'

import './style.scss'
import Autosuggest from 'react-autosuggest'
import { getText } from '../languages'


// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.

export default function RegionAutocomplete(props) {
  const { type, zipcodes, populations, regionValue, setRegionValue, language } = props;
  const isWorld = type === 'world';
  const minInputLength = isWorld ? 1 : 3;

  const countriesFromPopulations = useMemo(() => { // special case search changes here
    if (populations) {
      return Object.keys(populations).map(key => {
        const country = populations[key];
        if (country.country && country.country.jhName === 'Congo (Brazzaville)') {
          country.country.jhName = '';
        }
        return country;
      });
    }
    return [];
  }, [populations]);

  const [inputValue, setInputValue] = useState(regionValue);
  useEffect(() => {
    setInputValue(regionValue);
  }, [regionValue]);

  const [suggestions, setSuggestions] = useState([])

  const getSuggestionValue = suggestion => {
    return isWorld ? suggestion.id : suggestion.fips
  }

  const getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
    if (inputLength < minInputLength) {
      return []
    }
    let suggestions = []
    if (inputValue.match(/^[0-9]+$/) && !isWorld) {
      suggestions = zipcodes.filter(zip =>
        zip.zip.slice(0, inputLength) === inputValue
      )
    } else {
      // switch here for countries
      suggestions = countriesFromPopulations.filter(region => {
        if (isWorld) {
          if (region.country) {
            return (
              region.country.name.toLowerCase().includes(inputValue)
                ||
              region.country.jhName.toLowerCase().includes(inputValue)
                ||
              region.country.whoName.toLowerCase().includes(inputValue)
                ||
              getText(language, region.country.name).toLowerCase().includes(inputValue)
            );
          } else {
            return region.region.name.toLowerCase().includes(inputValue) ||
              (region.region.jhName && region.region.jhName.toLowerCase().includes(inputValue)) ||
              (region.region.topoName && region.region.topoName.toLowerCase().includes(inputValue)) ||
              (region.region.populationName && region.region.populationName.toLowerCase().includes(inputValue)) ||
              getText(language, region.region.name).toLowerCase().includes(inputValue)
          }
        } else {
          if (region.COUNTY === '0') {
            // this is a state, we don't want to allow this to be selected
            return false
          }
          if (!region.CTYNAME) {
            return false
          }
          return region.CTYNAME.toLowerCase().slice(0, inputLength) === inputValue
        }
      })
    }
    return suggestions;
  };


  // Use your imagination to render suggestions.
  const renderSuggestion = suggestion => {
    if (isWorld) {
      return (
        <div>
          {getText(language, suggestion.name)}
        </div>
      );
    }
    if (inputValue.trim().toLowerCase().match(/^[0-9]+$/)) {
      return (
        <div>
          {suggestion.zip} ({suggestion.county} County, {suggestion.stateAbbr})
        </div>
      )
    }
    return (
      <div>
        {suggestion.CTYNAME}, {suggestion.stateAbbr}
      </div>
    )
  };


  const onChange = (event, { newValue, method }) => {
    if (['enter', 'click'].includes(method)) {
      const region = populations[newValue]
      if (region) {
        const regionText = isWorld
          ? region.name
          : `${region.CTYNAME}, ${region.stateAbbr}`;
        setRegionValue({ label: regionText, id: newValue});
      } else {
        setRegionValue({ id: newValue, label: newValue })
      }
    } else if (['type'].includes(method)) {
      setInputValue(newValue)
    }
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value))
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  const onSuggestionsClearRequested = () => {
    setSuggestions([])
  };

  const onFocus = (event) => {
    event.target.select()
  }

  // Autosuggest will pass through all these props to the input.
  const inputProps = {
    placeholder: getText(language, isWorld ? 'searchPlaceholderWorld' : 'searchPlaceholderUS'),
    value: inputValue,
    onChange: onChange,
    onFocus: onFocus,
  };
  return (
    <div className={`RegionAutocomplete ${inputValue === '' ? 'placeholder' : ''}`}>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    </div>
  )
}